export default __webpack_public_path__ + "static/media/b4.d2aa8de3.svg";